module.exports = __webpack_public_path__ + "b62a199701c3e0954da2a83df3aab054.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-Bold.woff
// module id = 416
// module chunks = 0